import { ICoreWebView, ICoreWebViewPlugin } from '@fanduel/cpe-um-bundle/core-webview/library';

// matches: [any][transaction-history/casino-move]/[any]/[any]~[any]/[number][any/nothing]
const LINK_REGEX = new RegExp('.*(?:transaction-history|casino-move)\\/[^\\/]+\\/[^\\/~]+~[^\\/]+\\/\\d+.*');

const PLUGIN_ID = 'fanduel/casino/transaction-history-link-block';

export const onUrlBlocked = (_webview: ICoreWebView, url: string) => {
    try {
        const isTransactionHistoryUrl = LINK_REGEX.test(url);

        if (isTransactionHistoryUrl) {
            window.open(url, '_blank');
        }
    } catch (error) {
        console.warn(`Transaction History Plugin Error: ${(error as Error).message}`);
    }
};

export const TransactionHistoryLinkBlockPlugin: ICoreWebViewPlugin = {
    id: PLUGIN_ID,
    urlBlockList: [LINK_REGEX],
    onUrlBlocked
};
